module.exports = __webpack_public_path__ + "img/la-grande-cave-logo.60eeb52c.jpg";